const products = [
  {
    id: 1,
    name: "브랜딩의 과학",
    price: 26100,
    description: "브랜드 성장의 비밀을 과학적으로 파헤치다! 아마존 비즈니스 분야 3개 카테고리 베스트셀러!",
    image: "book1.jpg",
  },
  {
    id: 2,
    name: "나음보다 다름",
    price: 16200,
    description: "경쟁하지 말고 차별화하라! 현장의 실무자들에게 좀 더 현실적이고 실질적인 도움을 주는 데 주안점을 두고 사례와 과정을 자세히 소개한다.",
    image: "book2.jpg",
  },
  {
    id: 3,
    name: "그래서 브랜딩이 필요합니다",
    price: 12600,
    description: "차별화된 브랜딩 전략과 실행으로 신세대 브랜드 가치를 만들어낸 전우성 디렉터의 브랜딩에 대한 생각과 조언",
    image: "book3.jpg",
  },
  {
    id: 4,
    name: "사용자를 생각하게 하지마!",
    price: 16200,
    description: "‘웹과 모바일 사용성 원칙’ 바이블, 웹 사이트를 명료하게 만드는 사용성 원칙들을 유쾌하게 풀어낸다.",
    image: "book4.jpg",
  },
  {
    id: 5,
    name: "레이아웃 불변의 법칙 100가지",
    price: 28800,
    description: "모든 디자인의 기본, 그리드! 디자이너 필독서",
    image: "book5.jpg",
  },
  {
    id: 6,
    name: "좋은 문서디자인 기본 원리 29",
    price: 13000,
    description: "『좋은 문서디자인 기본 원리 29』는 일상 속에서 누구나 쉽게 익히고 쓸 수 있는 문서디자인 기본 원리 29가지를 다룬다.",
    image: "book6.jpg",
  },
  {
    id: 7,
    name: "트렌드 코리아 2025",
    price: 18000,
    description: "경계가 사라지는 시대, 모든 전제를 원점으로 되돌려라. 2025년에도 돌아온 트렌드 코리아!",
    image: "book7.jpg",
  },
  {
    id: 8,
    name: "브랜드의 거짓말",
    price: 17100,
    description: "“장담컨대, 당신이 봐왔고, 보게 될 모든 광고는 이 법칙들을 넘어설 수 없다” 마케팅계의 거장 마틴 린드스트롬의 명저 브랜드 마케팅의 전설적 바이블",
    image: "book8.jpg",
  },
];

export default products;